import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "grid four" }
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = { class: "grid" }
const _hoisted_5 = { class: "section" }
const _hoisted_6 = { class: "grid two" }
const _hoisted_7 = {
  class: "upload-card",
  "element-loading-text": "上传中...",
  "element-loading-background": "rgba(255,255,255,0.6)"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "upload-icon" }
const _hoisted_10 = {
  class: "upload-card",
  "element-loading-text": "上传中...",
  "element-loading-background": "rgba(255,255,255,0.6)"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "upload-icon" }
const _hoisted_13 = { class: "section" }
const _hoisted_14 = { class: "grid two" }
const _hoisted_15 = {
  class: "upload-card",
  "element-loading-text": "上传中...",
  "element-loading-background": "rgba(255,255,255,0.6)"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "upload-icon" }
const _hoisted_18 = {
  class: "upload-card",
  "element-loading-text": "上传中...",
  "element-loading-background": "rgba(255,255,255,0.6)"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "upload-icon" }
const _hoisted_21 = { class: "footer-actions" }

import { ref, reactive, computed, watch, onMounted } from 'vue'
import { ElDialog, ElButton, ElForm, ElFormItem, ElInput, ElSelect, ElOption, ElUpload, ElMessage, ElIcon, ElCascader } from 'element-plus'
//@ts-ignore
import areaData from '@/common/area.json'
import { Upload } from '@element-plus/icons-vue'
import { uploadfiles } from '@/api/plugin'
import { businessApply, uploadImage, getDesignerApplyDict, editBusinessDetail } from '@/api/match'

export default /*@__PURE__*/_defineComponent({
  __name: 'MerchantImageDialog',
  props: {
    visible: { type: Boolean },
    businessDetail: {}
  },
  emits: ['update:visible', 'save', 'submit'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const innerVisible = computed({
  get: () => props.visible,
  set: v => emit('update:visible', v)
})
watch(() => props.visible, (newVal) => {
  if (newVal) {
    console.log('qweqweqew')
    let businessDetail = props.businessDetail || {}
    restoreForm(businessDetail)
  }
})
watch(() => props.businessDetail, (bd) => {
  if (innerVisible.value) {
    restoreForm(bd || {})
  }
}, { deep: true })
const formRef = ref()
const form = reactive({ name: '', region: [] as Array<string | number>, contact: '', platform_user_name: '', id_card: '', desc: '', address: '', logo: null as File | null, license: null as File | null, id_card_front: null as File | null, id_card_back: null as File | null, logoUrl: '', licenseUrl: '', licenseType: '', licenseName: '', idCardFrontUrl: '', idCardBackUrl: '' })
const logoUploading = ref(false)
const licenseUploading = ref(false)
const idCardFrontUploading = ref(false)
const idCardBackUploading = ref(false)
const regionOptions = ref<any[]>([])
const regionRef = ref()
const detailId = ref('')
const restoreForm = (bd: Record<string, any> = {}) => {
  console.log(bd)
  form.name = bd.company_name || bd.customer_name || ''
  form.contact = bd.contact_person || ''
  form.platform_user_name = bd.platform_user_name || ''
  form.id_card = bd.id_card || ''
  form.address = bd.address || ''
  form.desc = bd.introduce || ''
  form.logo = bd.logo || null
  form.id_card_front = bd.id_card_front || null
  form.id_card_back = bd.id_card_back || null
  form.logoUrl = bd.logo || ''
  form.licenseUrl = bd.license || ''
  form.license = bd.license || ''
  form.idCardFrontUrl = bd.id_card_front || ''
  form.idCardBackUrl = bd.id_card_back || ''
  const codes = [bd.province_code, bd.city_code, bd.district_code].filter(Boolean)
  form.region = codes as Array<string | number>
  detailId.value = bd.id || ''
}

const rules = {
  name: [{ required: true, message: '请输入商家名称', trigger: 'blur' }],
  region: [{ required: true, message: '请选择省市区', trigger: 'change' }],
  contact: [{ required: true, message: '请输入联系人姓名', trigger: 'blur' }],
  platform_user_name: [{ required: true, message: '请输入平台用户名', trigger: 'blur' }],
  id_card: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
  desc: [{ required: true, message: '请输入商家描述', trigger: 'blur' }],
  address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
  logo: [{ required: true, message: '请上传商家 Logo', trigger: 'change' }],
  license: [{ required: true, message: '请上传营业执照', trigger: 'change' }],
  id_card_front: [{ required: true, message: '请上传身份证正面', trigger: 'change' }],
  id_card_back: [{ required: true, message: '请上传身份证背面', trigger: 'change' }]
}
const readImageSize = (file: File) => new Promise<{ w: number, h: number }>((resolve, reject) => {
  const url = URL.createObjectURL(file)
  const img = new Image()
  img.onload = () => { resolve({ w: img.width, h: img.height }); URL.revokeObjectURL(url) }
  img.onerror = () => { reject(); URL.revokeObjectURL(url) }
  img.src = url
})
const handleLogoBefore = async (file: File) => {
  const okType = ['image/png', 'image/jpeg'].includes(file.type)
  if (!okType) { ElMessage.error('仅支持 PNG、JPG 格式'); return false }
  const size = await readImageSize(file)
  if (size.w < 200 || size.h < 200) { ElMessage.error('尺寸需不小于 200×200px'); return false }
  return true
}
const handleLogoUpload = async (option: any) => {
  logoUploading.value = true
  try {
    const raw: File = option?.file?.raw || option?.file
    const fd = new FormData()
    fd.append('file', raw, raw?.name || 'file')
    const res = await uploadImage(fd)
    const url = res?.data?.data?.url || ''
    if (url) {
      form.logo = raw
      form.logoUrl = url
    }
    console.log('logoUrl', form.logoUrl)
    option?.onSuccess?.(res?.data, option?.file)
  } catch (e) {
    option?.onError?.(e)
    ElMessage.error('上传失败')
  } finally {
    logoUploading.value = false
  }
}
const handleLicenseBefore = async (file: File) => {
  const okType = ['image/png', 'image/jpeg', 'application/pdf'].includes(file.type)
  if (!okType) { ElMessage.error('仅支持 PNG、JPG、PDF 格式'); return false }
  return true
}
const handleLicenseUpload = async (option: any) => {
  licenseUploading.value = true
  try {
    const raw: File = option?.file?.raw || option?.file
    const fd = new FormData()
    fd.append('file', raw, raw?.name || 'file')
    const res = await uploadImage(fd)
    const url = res?.data?.data?.url || ''
    if (url) {
      form.license = raw
      form.licenseUrl = url
      form.licenseType = raw?.type || ''
      form.licenseName = raw?.name || ''
    }
    option?.onSuccess?.(res?.data, option?.file)
  } catch (e) {
    option?.onError?.(e)
    ElMessage.error('上传失败')
  } finally {
    licenseUploading.value = false
  }
}
const handleIdCardFrontBefore = async (file: File) => {
  const okType = ['image/png', 'image/jpeg'].includes(file.type)
  if (!okType) { ElMessage.error('仅支持 PNG、JPG 格式'); return false }
  return true
}
const handleIdCardFrontUpload = async (option: any) => {
  idCardFrontUploading.value = true
  try {
    const raw: File = option?.file?.raw || option?.file
    const fd = new FormData()
    fd.append('file', raw, raw?.name || 'file')
    const res = await uploadImage(fd)
    const url = res?.data?.data?.url || ''
    if (url) {
      form.id_card_front = raw
      form.idCardFrontUrl = url
    }
    option?.onSuccess?.(res?.data, option?.file)
  } catch (e) {
    option?.onError?.(e)
    ElMessage.error('上传失败')
  } finally {
    idCardFrontUploading.value = false
  }
}
const handleIdCardBackBefore = async (file: File) => {
  const okType = ['image/png', 'image/jpeg'].includes(file.type)
  if (!okType) { ElMessage.error('仅支持 PNG、JPG 格式'); return false }
  return true
}
const handleIdCardBackUpload = async (option: any) => {
  idCardBackUploading.value = true
  try {
    const raw: File = option?.file?.raw || option?.file
    const fd = new FormData()
    fd.append('file', raw, raw?.name || 'file')
    const res = await uploadImage(fd)
    const url = res?.data?.data?.url || ''
    if (url) {
      form.id_card_back = raw
      form.idCardBackUrl = url
    }
    option?.onSuccess?.(res?.data, option?.file)
  } catch (e) {
    option?.onError?.(e)
    ElMessage.error('上传失败')
  } finally {
    idCardBackUploading.value = false
  }
}
const onCancel = () => { emit('update:visible', false) }
const onSave = () => { emit('save', { ...form }) }
const onSubmit = () => {
  formRef.value?.validate((valid: boolean) => {
    if (valid) {
      const codes: (string | number)[] = Array.isArray(form.region) ? form.region : [form.region].filter(Boolean)
      let names: string[] = []
      try {
        const node = regionRef.value?.getCheckedNodes?.()[0]
        names = Array.isArray(node?.pathLabels) ? node.pathLabels : []

      } catch { }

      const payload = {
        user_type: 1,
        company_name: form.name,
        // customer_name: form.name,
        contact_person: form.contact,
        platform_user_name: form.platform_user_name,
        id_card: form.id_card,
        id_card_front: form.idCardFrontUrl || '',
        id_card_back: form.idCardBackUrl || '',
        logo: form.logoUrl || '',
        license: form.licenseUrl || '',
        province_code: codes[0] || '',
        city_code: codes[1] || '',
        district_code: codes[2] || '',
        province_name: names[0] || '',
        city_name: names[1] || '',
        district_name: names[2] || '',
        address: form.address,
        introduce: form.desc,
        origin_type: 2
      }
      let api = businessApply
      if (detailId.value) {
        (payload as Record<string, any>).id = detailId.value
        api = editBusinessDetail
      }
      console.log(payload)
      api(payload).then(res => {
        if (res?.data?.code === 200) {
          ElMessage.success(res?.data?.message || '申请成功')
          innerVisible.value = false
          window.location.reload()
        }

        // onCancel()
      })
    }
  })
}

onMounted(() => {
  loadRegionOptions()
  getopt()
})

const professionalOptions = ref([])
const experienceOptions = ref([])
const loadRegionOptions = async () => {
  regionOptions.value = areaData
}
const getopt = async () => {
  let po = await getDesignerApplyDict({ parent_id: '46' })
  let eo = await getDesignerApplyDict({ parent_id: '43' })
  professionalOptions.value = po?.data?.data || []
  experienceOptions.value = eo?.data?.data || []
}



return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(ElDialog), {
    modelValue: innerVisible.value,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((innerVisible).value = $event)),
    title: detailId.value ? '修改商户信息' : '申请入驻',
    width: "1400px",
    "align-center": "",
    class: "merchant-dialog"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_unref(ElButton), { onClick: onCancel }, {
          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(ElButton), {
          type: "primary",
          onClick: onSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(detailId.value ? '修改商户信息' : '提交申请'), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "hint" }, "请填写以下信息完成商家入驻申请，所有字段均为必填。提交后我们将在 1-3 个工作日内核您的申请，请保持联系畅通", -1)),
      _createVNode(_unref(ElForm), {
        ref_key: "formRef",
        ref: formRef,
        model: form,
        rules: rules,
        "label-position": "top",
        class: "form"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "section-title" }, "基本信息", -1)),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(ElFormItem), {
                label: "商家名称 *",
                prop: "name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElInput), {
                    modelValue: form.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event)),
                    placeholder: "请输入商家名称"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(ElFormItem), {
                label: "省市区 *",
                prop: "region"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElCascader), {
                    ref_key: "regionRef",
                    ref: regionRef,
                    modelValue: form.region,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.region) = $event)),
                    options: regionOptions.value,
                    style: {"width":"100%"},
                    props: { value: 'code', label: 'name', children: 'children', emitPath: true },
                    filterable: "",
                    placeholder: "请选择省/市/区"
                  }, {
                    label: _withCtx(({ node, data }) => [
                      _createTextVNode(_toDisplayString(data.name) + " " + _toDisplayString(node), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options"])
                ]),
                _: 1
              }),
              _createVNode(_unref(ElFormItem), {
                label: "联系人 *",
                prop: "contact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElInput), {
                    modelValue: form.contact,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.contact) = $event)),
                    placeholder: "请输入联系人姓名"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(ElFormItem), {
                label: "详细地址 *",
                prop: "address"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElInput), {
                    modelValue: form.address,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.address) = $event)),
                    placeholder: "请输入详细经营地址"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(ElFormItem), {
                label: "平台用户名 *",
                prop: "platform_user_name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElInput), {
                    modelValue: form.platform_user_name,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.platform_user_name) = $event)),
                    placeholder: "请输入平台用户名"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(ElFormItem), {
                label: "身份证号 *",
                prop: "id_card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElInput), {
                    modelValue: form.id_card,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.id_card) = $event)),
                    placeholder: "请输入身份证号"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_unref(ElFormItem), {
              label: "商家描述 *",
              prop: "desc"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  modelValue: form.desc,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.desc) = $event)),
                  type: "textarea",
                  rows: 5,
                  maxlength: "500",
                  "show-word-limit": "",
                  placeholder: "请简要描述商家主营业务、特色产品或服务等信息"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "section-title" }, "身份证照片", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(ElFormItem), {
                  label: "身份证正面 *",
                  prop: "id_card_front"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElUpload), {
                      class: "uploader",
                      drag: "",
                      "show-file-list": false,
                      style: {"width":"100%"},
                      "before-upload": handleIdCardFrontBefore,
                      "http-request": handleIdCardFrontUpload
                    }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (form.idCardFrontUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: form.idCardFrontUrl,
                                class: "upload-preview"
                              }, null, 8, _hoisted_8))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_9, [
                                  _createVNode(_unref(ElIcon), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Upload))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "upload-text-main" }, "点击上传或拖放文件至此处", -1)),
                                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "upload-text-sub" }, "支持 PNG、JPG 格式", -1))
                              ], 64))
                        ])), [
                          [_directive_loading, idCardFrontUploading.value]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(ElFormItem), {
                  label: "身份证背面 *",
                  prop: "id_card_back"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElUpload), {
                      class: "uploader",
                      drag: "",
                      "show-file-list": false,
                      style: {"width":"100%"},
                      "before-upload": handleIdCardBackBefore,
                      "http-request": handleIdCardBackUpload
                    }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (form.idCardBackUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: form.idCardBackUrl,
                                class: "upload-preview"
                              }, null, 8, _hoisted_11))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_12, [
                                  _createVNode(_unref(ElIcon), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Upload))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "upload-text-main" }, "点击上传或拖放文件至此处", -1)),
                                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "upload-text-sub" }, "支持 PNG、JPG 格式", -1))
                              ], 64))
                        ])), [
                          [_directive_loading, idCardBackUploading.value]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "section-title" }, "资质证明", -1)),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_unref(ElFormItem), {
                  label: "商家Logo *",
                  prop: "logo"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElUpload), {
                      class: "uploader",
                      drag: "",
                      "show-file-list": false,
                      style: {"width":"100%"},
                      "before-upload": handleLogoBefore,
                      "http-request": handleLogoUpload
                    }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (form.logoUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: form.logoUrl,
                                class: "upload-preview"
                              }, null, 8, _hoisted_16))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_17, [
                                  _createVNode(_unref(ElIcon), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Upload))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "upload-text-main" }, "点击上传或拖放文件至此处", -1)),
                                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "upload-text-sub" }, "支持 PNG、JPG 格式", -1))
                              ], 64))
                        ])), [
                          [_directive_loading, logoUploading.value]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(ElFormItem), {
                  label: "营业执照 *",
                  prop: "license"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElUpload), {
                      class: "uploader",
                      drag: "",
                      "show-file-list": false,
                      style: {"width":"100%"},
                      "before-upload": handleLicenseBefore,
                      "http-request": handleLicenseUpload
                    }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [
                          (form.licenseUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: form.licenseUrl,
                                class: "upload-preview"
                              }, null, 8, _hoisted_19))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_20, [
                                  _createVNode(_unref(ElIcon), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Upload))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "upload-text-main" }, "点击上传或拖放文件至此处", -1)),
                                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "upload-text-sub" }, "支持 PNG、JPG格式", -1))
                              ], 64))
                        ])), [
                          [_directive_loading, licenseUploading.value]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})